import { ScreenType } from '../../interfaces/platform/Platform'
import { platform } from './platform'

export default function getScreenType (): ScreenType {
  return platform === 'web' && window.innerWidth > window.innerHeight ? 'web' : 'mobile'
}
